/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddPlaceholderRequestV2 } from '../api-models';
// @ts-ignore
import { AuditResponse } from '../api-models';
// @ts-ignore
import { OpenShiftsBusinessObjectsResponseScheduleSchedulePlaceholderResponseV2 } from '../api-models';
// @ts-ignore
import { PlaceholderAddFormConfigurationResponseV2 } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { ScheduleAddFormConfigurationResponseV2 } from '../api-models';
// @ts-ignore
import { ScheduleConfigurationResponseV2 } from '../api-models';
// @ts-ignore
import { ScheduleDetailResponseV2 } from '../api-models';
// @ts-ignore
import { ScheduleDetailedRequestV2 } from '../api-models';
// @ts-ignore
import { ScheduleResponseV2 } from '../api-models';
/**
 * ScheduleV2Api - axios parameter creator
 * @export
 */
export const ScheduleV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns Add-form defaults for the Schedule Add dialog. Replaces TaAPI  `GET /api/Schedule/ScheduleAddFormConfiguration`. Distinct shape from the  generic `SchedulesConfiguration` endpoint — see  OpenShifts.BusinessObjects.Response.Schedule.ScheduleAddFormConfigurationResponseV2.
         * @param {number} employeeId 
         * @param {string} payDate 
         * @param {number} shiftId 
         * @param {Array<number>} [laborLevels] 
         * @param {number} [subShiftId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleAddFormConfigurationGet: async (employeeId: number, payDate: string, shiftId: number, laborLevels?: Array<number>, subShiftId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2ScheduleAddFormConfigurationGet', 'employeeId', employeeId)
            // verify required parameter 'payDate' is not null or undefined
            assertParamExists('apiV2ScheduleAddFormConfigurationGet', 'payDate', payDate)
            // verify required parameter 'shiftId' is not null or undefined
            assertParamExists('apiV2ScheduleAddFormConfigurationGet', 'shiftId', shiftId)
            const localVarPath = `/api/v2/schedule/add-form-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }

            if (shiftId !== undefined) {
                localVarQueryParameter['shiftId'] = shiftId;
            }

            if (laborLevels) {
                localVarQueryParameter['laborLevels'] = laborLevels;
            }

            if (subShiftId !== undefined) {
                localVarQueryParameter['subShiftId'] = subShiftId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the per-(employee, payDate) defaults + permission flags used by the Schedule  Add/Edit dialog. Replaces TaAPI `GET /api/Schedule/SchedulesConfiguration`.
         * @param {string} payDate 
         * @param {number} [pkEmployeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleConfigurationGet: async (payDate: string, pkEmployeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payDate' is not null or undefined
            assertParamExists('apiV2ScheduleConfigurationGet', 'payDate', payDate)
            const localVarPath = `/api/v2/schedule/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pkEmployeeId !== undefined) {
                localVarQueryParameter['pkEmployeeId'] = pkEmployeeId;
            }

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add or update a fully-specified schedule row. Returns the resulting PkScheduleId.  Replaces TaAPI `POST /api/Schedule/ScheduleDetailed`.
         * @param {ScheduleDetailedRequestV2} [scheduleDetailedRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleDetailsPost: async (scheduleDetailedRequestV2?: ScheduleDetailedRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/schedule/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleDetailedRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns schedules for the employee in [start, end] (inclusive on PayDate). Replaces  TaAPI `GET /api/Schedule/Schedules`.
         * @param {string} startDateTime 
         * @param {string} endDateTime 
         * @param {number} [pkEmployeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleGet: async (startDateTime: string, endDateTime: string, pkEmployeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDateTime' is not null or undefined
            assertParamExists('apiV2ScheduleGet', 'startDateTime', startDateTime)
            // verify required parameter 'endDateTime' is not null or undefined
            assertParamExists('apiV2ScheduleGet', 'endDateTime', endDateTime)
            const localVarPath = `/api/v2/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pkEmployeeId !== undefined) {
                localVarQueryParameter['pkEmployeeId'] = pkEmployeeId;
            }

            if (startDateTime !== undefined) {
                localVarQueryParameter['startDateTime'] = (startDateTime as any instanceof Date) ?
                    (startDateTime as any).toISOString() :
                    startDateTime;
            }

            if (endDateTime !== undefined) {
                localVarQueryParameter['endDateTime'] = (endDateTime as any instanceof Date) ?
                    (endDateTime as any).toISOString() :
                    endDateTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the placeholder Add-form configuration. Replaces TaAPI  `GET /api/Schedule/PlaceHolderAddFormConfiguration`. Distinct shape from the  generic `SchedulesConfiguration` endpoint — see  OpenShifts.BusinessObjects.Response.Schedule.PlaceholderAddFormConfigurationResponseV2.
         * @param {number} employeeId 
         * @param {string} payDate 
         * @param {number} [scheduleId] 
         * @param {boolean} [isEditMode] 
         * @param {string} [shiftId] 
         * @param {number} [selectedScheduleStatusTypeId] 
         * @param {number} [placeholderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholderAddFormConfigurationGet: async (employeeId: number, payDate: string, scheduleId?: number, isEditMode?: boolean, shiftId?: string, selectedScheduleStatusTypeId?: number, placeholderId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2SchedulePlaceholderAddFormConfigurationGet', 'employeeId', employeeId)
            // verify required parameter 'payDate' is not null or undefined
            assertParamExists('apiV2SchedulePlaceholderAddFormConfigurationGet', 'payDate', payDate)
            const localVarPath = `/api/v2/schedule/placeholder-add-form-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }

            if (scheduleId !== undefined) {
                localVarQueryParameter['scheduleId'] = scheduleId;
            }

            if (isEditMode !== undefined) {
                localVarQueryParameter['isEditMode'] = isEditMode;
            }

            if (shiftId !== undefined) {
                localVarQueryParameter['shiftId'] = shiftId;
            }

            if (selectedScheduleStatusTypeId !== undefined) {
                localVarQueryParameter['selectedScheduleStatusTypeId'] = selectedScheduleStatusTypeId;
            }

            if (placeholderId !== undefined) {
                localVarQueryParameter['placeholderId'] = placeholderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Audit trail for one placeholder row. Replaces TaAPI  `GET /api/Schedule/PlaceholderAudits`.
         * @param {number} placeholderId 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholderPlaceholderIdAuditsGet: async (placeholderId: number, employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placeholderId' is not null or undefined
            assertParamExists('apiV2SchedulePlaceholderPlaceholderIdAuditsGet', 'placeholderId', placeholderId)
            const localVarPath = `/api/v2/schedule/placeholder/{placeholderId}/audits`
                .replace(`{${"placeholderId"}}`, encodeURIComponent(String(placeholderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns one placeholder by id (employee-scoped), or 204 when not found. Replaces TaAPI  `GET /api/Schedule/SchedulePlaceHolder`.
         * @param {number} placeholderId 
         * @param {number} [pkEmployeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholderPlaceholderIdGet: async (placeholderId: number, pkEmployeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placeholderId' is not null or undefined
            assertParamExists('apiV2SchedulePlaceholderPlaceholderIdGet', 'placeholderId', placeholderId)
            const localVarPath = `/api/v2/schedule/placeholder/{placeholderId}`
                .replace(`{${"placeholderId"}}`, encodeURIComponent(String(placeholderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pkEmployeeId !== undefined) {
                localVarQueryParameter['pkEmployeeId'] = pkEmployeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add or update a placeholder. Replaces TaAPI  `POST /api/Schedule/AddOrUpdatePlaceholder`. NOTE: `POST /api/v2/timecard/placeholder`  (TimeCardV2Controller.AddSchedulePlaceholderAsync) covers a narrower add-only contract;  this endpoint mirrors legacy add-or-update + comment-upsert semantics faithfully.
         * @param {AddPlaceholderRequestV2} [addPlaceholderRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholderPost: async (addPlaceholderRequestV2?: AddPlaceholderRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/schedule/placeholder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPlaceholderRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns schedule placeholders for the employee in [start, end]. Replaces TaAPI  `GET /api/Schedule/SchedulePlaceHolders`.
         * @param {string} startDateTime 
         * @param {string} endDateTime 
         * @param {number} [pkEmployeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholdersGet: async (startDateTime: string, endDateTime: string, pkEmployeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDateTime' is not null or undefined
            assertParamExists('apiV2SchedulePlaceholdersGet', 'startDateTime', startDateTime)
            // verify required parameter 'endDateTime' is not null or undefined
            assertParamExists('apiV2SchedulePlaceholdersGet', 'endDateTime', endDateTime)
            const localVarPath = `/api/v2/schedule/placeholders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pkEmployeeId !== undefined) {
                localVarQueryParameter['pkEmployeeId'] = pkEmployeeId;
            }

            if (startDateTime !== undefined) {
                localVarQueryParameter['startDateTime'] = (startDateTime as any instanceof Date) ?
                    (startDateTime as any).toISOString() :
                    startDateTime;
            }

            if (endDateTime !== undefined) {
                localVarQueryParameter['endDateTime'] = (endDateTime as any instanceof Date) ?
                    (endDateTime as any).toISOString() :
                    endDateTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Audit trail for one schedule row. 204 when the schedule doesn\'t belong to the supplied  employee OR no audits exist. Replaces TaAPI `GET /api/Schedule/ScheduleAudits`.
         * @param {number} scheduleId 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleScheduleIdAuditsGet: async (scheduleId: number, employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('apiV2ScheduleScheduleIdAuditsGet', 'scheduleId', scheduleId)
            const localVarPath = `/api/v2/schedule/{scheduleId}/audits`
                .replace(`{${"scheduleId"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the editable detail of one schedule row, or 204 when not found. Replaces TaAPI  `GET /api/Schedule/GetSchedule`. Emits the RICH  OpenShifts.BusinessObjects.Response.Schedule.ScheduleDetailResponseV2 shape (mirror of TaAPI `ScheduleDetailedResponse`)  so the FE edit-schedule modal can drive its form-state from V2.
         * @param {number} scheduleId 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleScheduleIdGet: async (scheduleId: number, employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('apiV2ScheduleScheduleIdGet', 'scheduleId', scheduleId)
            const localVarPath = `/api/v2/schedule/{scheduleId}`
                .replace(`{${"scheduleId"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduleV2Api - functional programming interface
 * @export
 */
export const ScheduleV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScheduleV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns Add-form defaults for the Schedule Add dialog. Replaces TaAPI  `GET /api/Schedule/ScheduleAddFormConfiguration`. Distinct shape from the  generic `SchedulesConfiguration` endpoint — see  OpenShifts.BusinessObjects.Response.Schedule.ScheduleAddFormConfigurationResponseV2.
         * @param {number} employeeId 
         * @param {string} payDate 
         * @param {number} shiftId 
         * @param {Array<number>} [laborLevels] 
         * @param {number} [subShiftId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ScheduleAddFormConfigurationGet(employeeId: number, payDate: string, shiftId: number, laborLevels?: Array<number>, subShiftId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleAddFormConfigurationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ScheduleAddFormConfigurationGet(employeeId, payDate, shiftId, laborLevels, subShiftId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the per-(employee, payDate) defaults + permission flags used by the Schedule  Add/Edit dialog. Replaces TaAPI `GET /api/Schedule/SchedulesConfiguration`.
         * @param {string} payDate 
         * @param {number} [pkEmployeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ScheduleConfigurationGet(payDate: string, pkEmployeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleConfigurationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ScheduleConfigurationGet(payDate, pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add or update a fully-specified schedule row. Returns the resulting PkScheduleId.  Replaces TaAPI `POST /api/Schedule/ScheduleDetailed`.
         * @param {ScheduleDetailedRequestV2} [scheduleDetailedRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ScheduleDetailsPost(scheduleDetailedRequestV2?: ScheduleDetailedRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ScheduleDetailsPost(scheduleDetailedRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns schedules for the employee in [start, end] (inclusive on PayDate). Replaces  TaAPI `GET /api/Schedule/Schedules`.
         * @param {string} startDateTime 
         * @param {string} endDateTime 
         * @param {number} [pkEmployeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ScheduleGet(startDateTime: string, endDateTime: string, pkEmployeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScheduleResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ScheduleGet(startDateTime, endDateTime, pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the placeholder Add-form configuration. Replaces TaAPI  `GET /api/Schedule/PlaceHolderAddFormConfiguration`. Distinct shape from the  generic `SchedulesConfiguration` endpoint — see  OpenShifts.BusinessObjects.Response.Schedule.PlaceholderAddFormConfigurationResponseV2.
         * @param {number} employeeId 
         * @param {string} payDate 
         * @param {number} [scheduleId] 
         * @param {boolean} [isEditMode] 
         * @param {string} [shiftId] 
         * @param {number} [selectedScheduleStatusTypeId] 
         * @param {number} [placeholderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SchedulePlaceholderAddFormConfigurationGet(employeeId: number, payDate: string, scheduleId?: number, isEditMode?: boolean, shiftId?: string, selectedScheduleStatusTypeId?: number, placeholderId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceholderAddFormConfigurationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2SchedulePlaceholderAddFormConfigurationGet(employeeId, payDate, scheduleId, isEditMode, shiftId, selectedScheduleStatusTypeId, placeholderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Audit trail for one placeholder row. Replaces TaAPI  `GET /api/Schedule/PlaceholderAudits`.
         * @param {number} placeholderId 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SchedulePlaceholderPlaceholderIdAuditsGet(placeholderId: number, employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2SchedulePlaceholderPlaceholderIdAuditsGet(placeholderId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns one placeholder by id (employee-scoped), or 204 when not found. Replaces TaAPI  `GET /api/Schedule/SchedulePlaceHolder`.
         * @param {number} placeholderId 
         * @param {number} [pkEmployeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SchedulePlaceholderPlaceholderIdGet(placeholderId: number, pkEmployeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenShiftsBusinessObjectsResponseScheduleSchedulePlaceholderResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2SchedulePlaceholderPlaceholderIdGet(placeholderId, pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add or update a placeholder. Replaces TaAPI  `POST /api/Schedule/AddOrUpdatePlaceholder`. NOTE: `POST /api/v2/timecard/placeholder`  (TimeCardV2Controller.AddSchedulePlaceholderAsync) covers a narrower add-only contract;  this endpoint mirrors legacy add-or-update + comment-upsert semantics faithfully.
         * @param {AddPlaceholderRequestV2} [addPlaceholderRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SchedulePlaceholderPost(addPlaceholderRequestV2?: AddPlaceholderRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2SchedulePlaceholderPost(addPlaceholderRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns schedule placeholders for the employee in [start, end]. Replaces TaAPI  `GET /api/Schedule/SchedulePlaceHolders`.
         * @param {string} startDateTime 
         * @param {string} endDateTime 
         * @param {number} [pkEmployeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2SchedulePlaceholdersGet(startDateTime: string, endDateTime: string, pkEmployeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenShiftsBusinessObjectsResponseScheduleSchedulePlaceholderResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2SchedulePlaceholdersGet(startDateTime, endDateTime, pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Audit trail for one schedule row. 204 when the schedule doesn\'t belong to the supplied  employee OR no audits exist. Replaces TaAPI `GET /api/Schedule/ScheduleAudits`.
         * @param {number} scheduleId 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ScheduleScheduleIdAuditsGet(scheduleId: number, employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ScheduleScheduleIdAuditsGet(scheduleId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the editable detail of one schedule row, or 204 when not found. Replaces TaAPI  `GET /api/Schedule/GetSchedule`. Emits the RICH  OpenShifts.BusinessObjects.Response.Schedule.ScheduleDetailResponseV2 shape (mirror of TaAPI `ScheduleDetailedResponse`)  so the FE edit-schedule modal can drive its form-state from V2.
         * @param {number} scheduleId 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ScheduleScheduleIdGet(scheduleId: number, employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleDetailResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ScheduleScheduleIdGet(scheduleId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScheduleV2Api - factory interface
 * @export
 */
export const ScheduleV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScheduleV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns Add-form defaults for the Schedule Add dialog. Replaces TaAPI  `GET /api/Schedule/ScheduleAddFormConfiguration`. Distinct shape from the  generic `SchedulesConfiguration` endpoint — see  OpenShifts.BusinessObjects.Response.Schedule.ScheduleAddFormConfigurationResponseV2.
         * @param {ScheduleV2ApiApiV2ScheduleAddFormConfigurationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleAddFormConfigurationGet(requestParameters: ScheduleV2ApiApiV2ScheduleAddFormConfigurationGetRequest, options?: AxiosRequestConfig): AxiosPromise<ScheduleAddFormConfigurationResponseV2> {
            return localVarFp.apiV2ScheduleAddFormConfigurationGet(requestParameters.employeeId, requestParameters.payDate, requestParameters.shiftId, requestParameters.laborLevels, requestParameters.subShiftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the per-(employee, payDate) defaults + permission flags used by the Schedule  Add/Edit dialog. Replaces TaAPI `GET /api/Schedule/SchedulesConfiguration`.
         * @param {ScheduleV2ApiApiV2ScheduleConfigurationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleConfigurationGet(requestParameters: ScheduleV2ApiApiV2ScheduleConfigurationGetRequest, options?: AxiosRequestConfig): AxiosPromise<ScheduleConfigurationResponseV2> {
            return localVarFp.apiV2ScheduleConfigurationGet(requestParameters.payDate, requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add or update a fully-specified schedule row. Returns the resulting PkScheduleId.  Replaces TaAPI `POST /api/Schedule/ScheduleDetailed`.
         * @param {ScheduleV2ApiApiV2ScheduleDetailsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleDetailsPost(requestParameters: ScheduleV2ApiApiV2ScheduleDetailsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2ScheduleDetailsPost(requestParameters.scheduleDetailedRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns schedules for the employee in [start, end] (inclusive on PayDate). Replaces  TaAPI `GET /api/Schedule/Schedules`.
         * @param {ScheduleV2ApiApiV2ScheduleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleGet(requestParameters: ScheduleV2ApiApiV2ScheduleGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<ScheduleResponseV2>> {
            return localVarFp.apiV2ScheduleGet(requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the placeholder Add-form configuration. Replaces TaAPI  `GET /api/Schedule/PlaceHolderAddFormConfiguration`. Distinct shape from the  generic `SchedulesConfiguration` endpoint — see  OpenShifts.BusinessObjects.Response.Schedule.PlaceholderAddFormConfigurationResponseV2.
         * @param {ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholderAddFormConfigurationGet(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGetRequest, options?: AxiosRequestConfig): AxiosPromise<PlaceholderAddFormConfigurationResponseV2> {
            return localVarFp.apiV2SchedulePlaceholderAddFormConfigurationGet(requestParameters.employeeId, requestParameters.payDate, requestParameters.scheduleId, requestParameters.isEditMode, requestParameters.shiftId, requestParameters.selectedScheduleStatusTypeId, requestParameters.placeholderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Audit trail for one placeholder row. Replaces TaAPI  `GET /api/Schedule/PlaceholderAudits`.
         * @param {ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholderPlaceholderIdAuditsGet(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2SchedulePlaceholderPlaceholderIdAuditsGet(requestParameters.placeholderId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns one placeholder by id (employee-scoped), or 204 when not found. Replaces TaAPI  `GET /api/Schedule/SchedulePlaceHolder`.
         * @param {ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholderPlaceholderIdGet(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<OpenShiftsBusinessObjectsResponseScheduleSchedulePlaceholderResponseV2> {
            return localVarFp.apiV2SchedulePlaceholderPlaceholderIdGet(requestParameters.placeholderId, requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add or update a placeholder. Replaces TaAPI  `POST /api/Schedule/AddOrUpdatePlaceholder`. NOTE: `POST /api/v2/timecard/placeholder`  (TimeCardV2Controller.AddSchedulePlaceholderAsync) covers a narrower add-only contract;  this endpoint mirrors legacy add-or-update + comment-upsert semantics faithfully.
         * @param {ScheduleV2ApiApiV2SchedulePlaceholderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholderPost(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholderPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2SchedulePlaceholderPost(requestParameters.addPlaceholderRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns schedule placeholders for the employee in [start, end]. Replaces TaAPI  `GET /api/Schedule/SchedulePlaceHolders`.
         * @param {ScheduleV2ApiApiV2SchedulePlaceholdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2SchedulePlaceholdersGet(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholdersGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<OpenShiftsBusinessObjectsResponseScheduleSchedulePlaceholderResponseV2>> {
            return localVarFp.apiV2SchedulePlaceholdersGet(requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Audit trail for one schedule row. 204 when the schedule doesn\'t belong to the supplied  employee OR no audits exist. Replaces TaAPI `GET /api/Schedule/ScheduleAudits`.
         * @param {ScheduleV2ApiApiV2ScheduleScheduleIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleScheduleIdAuditsGet(requestParameters: ScheduleV2ApiApiV2ScheduleScheduleIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2ScheduleScheduleIdAuditsGet(requestParameters.scheduleId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the editable detail of one schedule row, or 204 when not found. Replaces TaAPI  `GET /api/Schedule/GetSchedule`. Emits the RICH  OpenShifts.BusinessObjects.Response.Schedule.ScheduleDetailResponseV2 shape (mirror of TaAPI `ScheduleDetailedResponse`)  so the FE edit-schedule modal can drive its form-state from V2.
         * @param {ScheduleV2ApiApiV2ScheduleScheduleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ScheduleScheduleIdGet(requestParameters: ScheduleV2ApiApiV2ScheduleScheduleIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ScheduleDetailResponseV2> {
            return localVarFp.apiV2ScheduleScheduleIdGet(requestParameters.scheduleId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2ScheduleAddFormConfigurationGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2ScheduleAddFormConfigurationGetRequest
 */
export interface ScheduleV2ApiApiV2ScheduleAddFormConfigurationGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleAddFormConfigurationGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof ScheduleV2ApiApiV2ScheduleAddFormConfigurationGet
     */
    readonly payDate: string

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleAddFormConfigurationGet
     */
    readonly shiftId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof ScheduleV2ApiApiV2ScheduleAddFormConfigurationGet
     */
    readonly laborLevels?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleAddFormConfigurationGet
     */
    readonly subShiftId?: number
}

/**
 * Request parameters for apiV2ScheduleConfigurationGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2ScheduleConfigurationGetRequest
 */
export interface ScheduleV2ApiApiV2ScheduleConfigurationGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduleV2ApiApiV2ScheduleConfigurationGet
     */
    readonly payDate: string

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleConfigurationGet
     */
    readonly pkEmployeeId?: number
}

/**
 * Request parameters for apiV2ScheduleDetailsPost operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2ScheduleDetailsPostRequest
 */
export interface ScheduleV2ApiApiV2ScheduleDetailsPostRequest {
    /**
     * 
     * @type {ScheduleDetailedRequestV2}
     * @memberof ScheduleV2ApiApiV2ScheduleDetailsPost
     */
    readonly scheduleDetailedRequestV2?: ScheduleDetailedRequestV2
}

/**
 * Request parameters for apiV2ScheduleGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2ScheduleGetRequest
 */
export interface ScheduleV2ApiApiV2ScheduleGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduleV2ApiApiV2ScheduleGet
     */
    readonly startDateTime: string

    /**
     * 
     * @type {string}
     * @memberof ScheduleV2ApiApiV2ScheduleGet
     */
    readonly endDateTime: string

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleGet
     */
    readonly pkEmployeeId?: number
}

/**
 * Request parameters for apiV2SchedulePlaceholderAddFormConfigurationGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGetRequest
 */
export interface ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGet
     */
    readonly employeeId: number

    /**
     * 
     * @type {string}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGet
     */
    readonly payDate: string

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGet
     */
    readonly scheduleId?: number

    /**
     * 
     * @type {boolean}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGet
     */
    readonly isEditMode?: boolean

    /**
     * 
     * @type {string}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGet
     */
    readonly shiftId?: string

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGet
     */
    readonly selectedScheduleStatusTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGet
     */
    readonly placeholderId?: number
}

/**
 * Request parameters for apiV2SchedulePlaceholderPlaceholderIdAuditsGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdAuditsGetRequest
 */
export interface ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdAuditsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdAuditsGet
     */
    readonly placeholderId: number

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdAuditsGet
     */
    readonly employeeId?: number
}

/**
 * Request parameters for apiV2SchedulePlaceholderPlaceholderIdGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdGetRequest
 */
export interface ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdGet
     */
    readonly placeholderId: number

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdGet
     */
    readonly pkEmployeeId?: number
}

/**
 * Request parameters for apiV2SchedulePlaceholderPost operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2SchedulePlaceholderPostRequest
 */
export interface ScheduleV2ApiApiV2SchedulePlaceholderPostRequest {
    /**
     * 
     * @type {AddPlaceholderRequestV2}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholderPost
     */
    readonly addPlaceholderRequestV2?: AddPlaceholderRequestV2
}

/**
 * Request parameters for apiV2SchedulePlaceholdersGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2SchedulePlaceholdersGetRequest
 */
export interface ScheduleV2ApiApiV2SchedulePlaceholdersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholdersGet
     */
    readonly startDateTime: string

    /**
     * 
     * @type {string}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholdersGet
     */
    readonly endDateTime: string

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2SchedulePlaceholdersGet
     */
    readonly pkEmployeeId?: number
}

/**
 * Request parameters for apiV2ScheduleScheduleIdAuditsGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2ScheduleScheduleIdAuditsGetRequest
 */
export interface ScheduleV2ApiApiV2ScheduleScheduleIdAuditsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleScheduleIdAuditsGet
     */
    readonly scheduleId: number

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleScheduleIdAuditsGet
     */
    readonly employeeId?: number
}

/**
 * Request parameters for apiV2ScheduleScheduleIdGet operation in ScheduleV2Api.
 * @export
 * @interface ScheduleV2ApiApiV2ScheduleScheduleIdGetRequest
 */
export interface ScheduleV2ApiApiV2ScheduleScheduleIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleScheduleIdGet
     */
    readonly scheduleId: number

    /**
     * 
     * @type {number}
     * @memberof ScheduleV2ApiApiV2ScheduleScheduleIdGet
     */
    readonly employeeId?: number
}

/**
 * ScheduleV2Api - object-oriented interface
 * @export
 * @class ScheduleV2Api
 * @extends {BaseAPI}
 */
export class ScheduleV2Api extends BaseAPI {
    /**
     * 
     * @summary Returns Add-form defaults for the Schedule Add dialog. Replaces TaAPI  `GET /api/Schedule/ScheduleAddFormConfiguration`. Distinct shape from the  generic `SchedulesConfiguration` endpoint — see  OpenShifts.BusinessObjects.Response.Schedule.ScheduleAddFormConfigurationResponseV2.
     * @param {ScheduleV2ApiApiV2ScheduleAddFormConfigurationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2ScheduleAddFormConfigurationGet(requestParameters: ScheduleV2ApiApiV2ScheduleAddFormConfigurationGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2ScheduleAddFormConfigurationGet(requestParameters.employeeId, requestParameters.payDate, requestParameters.shiftId, requestParameters.laborLevels, requestParameters.subShiftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the per-(employee, payDate) defaults + permission flags used by the Schedule  Add/Edit dialog. Replaces TaAPI `GET /api/Schedule/SchedulesConfiguration`.
     * @param {ScheduleV2ApiApiV2ScheduleConfigurationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2ScheduleConfigurationGet(requestParameters: ScheduleV2ApiApiV2ScheduleConfigurationGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2ScheduleConfigurationGet(requestParameters.payDate, requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add or update a fully-specified schedule row. Returns the resulting PkScheduleId.  Replaces TaAPI `POST /api/Schedule/ScheduleDetailed`.
     * @param {ScheduleV2ApiApiV2ScheduleDetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2ScheduleDetailsPost(requestParameters: ScheduleV2ApiApiV2ScheduleDetailsPostRequest = {}, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2ScheduleDetailsPost(requestParameters.scheduleDetailedRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns schedules for the employee in [start, end] (inclusive on PayDate). Replaces  TaAPI `GET /api/Schedule/Schedules`.
     * @param {ScheduleV2ApiApiV2ScheduleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2ScheduleGet(requestParameters: ScheduleV2ApiApiV2ScheduleGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2ScheduleGet(requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the placeholder Add-form configuration. Replaces TaAPI  `GET /api/Schedule/PlaceHolderAddFormConfiguration`. Distinct shape from the  generic `SchedulesConfiguration` endpoint — see  OpenShifts.BusinessObjects.Response.Schedule.PlaceholderAddFormConfigurationResponseV2.
     * @param {ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2SchedulePlaceholderAddFormConfigurationGet(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholderAddFormConfigurationGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2SchedulePlaceholderAddFormConfigurationGet(requestParameters.employeeId, requestParameters.payDate, requestParameters.scheduleId, requestParameters.isEditMode, requestParameters.shiftId, requestParameters.selectedScheduleStatusTypeId, requestParameters.placeholderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Audit trail for one placeholder row. Replaces TaAPI  `GET /api/Schedule/PlaceholderAudits`.
     * @param {ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2SchedulePlaceholderPlaceholderIdAuditsGet(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2SchedulePlaceholderPlaceholderIdAuditsGet(requestParameters.placeholderId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns one placeholder by id (employee-scoped), or 204 when not found. Replaces TaAPI  `GET /api/Schedule/SchedulePlaceHolder`.
     * @param {ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2SchedulePlaceholderPlaceholderIdGet(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholderPlaceholderIdGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2SchedulePlaceholderPlaceholderIdGet(requestParameters.placeholderId, requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add or update a placeholder. Replaces TaAPI  `POST /api/Schedule/AddOrUpdatePlaceholder`. NOTE: `POST /api/v2/timecard/placeholder`  (TimeCardV2Controller.AddSchedulePlaceholderAsync) covers a narrower add-only contract;  this endpoint mirrors legacy add-or-update + comment-upsert semantics faithfully.
     * @param {ScheduleV2ApiApiV2SchedulePlaceholderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2SchedulePlaceholderPost(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholderPostRequest = {}, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2SchedulePlaceholderPost(requestParameters.addPlaceholderRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns schedule placeholders for the employee in [start, end]. Replaces TaAPI  `GET /api/Schedule/SchedulePlaceHolders`.
     * @param {ScheduleV2ApiApiV2SchedulePlaceholdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2SchedulePlaceholdersGet(requestParameters: ScheduleV2ApiApiV2SchedulePlaceholdersGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2SchedulePlaceholdersGet(requestParameters.startDateTime, requestParameters.endDateTime, requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Audit trail for one schedule row. 204 when the schedule doesn\'t belong to the supplied  employee OR no audits exist. Replaces TaAPI `GET /api/Schedule/ScheduleAudits`.
     * @param {ScheduleV2ApiApiV2ScheduleScheduleIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2ScheduleScheduleIdAuditsGet(requestParameters: ScheduleV2ApiApiV2ScheduleScheduleIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2ScheduleScheduleIdAuditsGet(requestParameters.scheduleId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the editable detail of one schedule row, or 204 when not found. Replaces TaAPI  `GET /api/Schedule/GetSchedule`. Emits the RICH  OpenShifts.BusinessObjects.Response.Schedule.ScheduleDetailResponseV2 shape (mirror of TaAPI `ScheduleDetailedResponse`)  so the FE edit-schedule modal can drive its form-state from V2.
     * @param {ScheduleV2ApiApiV2ScheduleScheduleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleV2Api
     */
    public apiV2ScheduleScheduleIdGet(requestParameters: ScheduleV2ApiApiV2ScheduleScheduleIdGetRequest, options?: AxiosRequestConfig) {
        return ScheduleV2ApiFp(this.configuration).apiV2ScheduleScheduleIdGet(requestParameters.scheduleId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}
